// @flow
import client from '../../client'
import format, { formatTwoDigits } from '../../utils/format'

// API Endpoints
export const GET_RESERVATIONS_ENDPOINT =
  '/reservations/travel_agent_reservations/{0}/{1}/'

/**
 * Returns reservations for a given date
 * @param {Object} data Date information
 * @param {number} data.month Date month
 * @param {number} data.year Date year
 * @return {Promise|Error} A resolved Promise with reservations or Rejected with an Error
 */
export const getReservations = (data: {
  month: number,
  year: number,
}): Promise<any> => {
  const { month, year } = data
  const formattedMonth = formatTwoDigits(month)
  const endpoint = format(GET_RESERVATIONS_ENDPOINT, formattedMonth, year)

  return client.get(endpoint)
}

export default getReservations
